import React, { useEffect } from 'react'
import { useNavigationContext } from '../context/NavigationContext';

const RootPage = () => {
    const {  goToDashboard } = useNavigationContext();
    useEffect(() => {
        goToDashboard(true);
    },[]);

  return (
   <progress className="progress w-56"></progress>
  )
}

export default RootPage